<template>
  <div
    id="email-recipient-stats"
  >
    <h3>
      {{ displayName }} #{{ baseId }} {{ status }} Recipients
    </h3>

    <email-recipient-status-key
      ref="statusKey"
      v-show="showKey"
    />

    <pagination
      ref="pagination"
      :pageResponse="pageResponse"
      :pageSize="$root.defaultPageSize"
      :resourceUrl="resourceUrl"
      :orderBy="this.orderBy"
      orderType="DESC"
    >
      <template
        slot="pagination_hdr"
        slot-scope="items"
      >
      </template>
      <template
        slot="paged_item"
        slot-scope="item"
        >
        <router-link
          :class="$root.listItemClasses + 'recipient ' + $refs['statusKey'].recipientClass(item)"
          :to="{
            name: recipientRoute,
            params: recipientParams(item)
          }"
        >
          {{ item.recipient_email }} ({{ $root.displayDateTimeFmt(item.queued_at) }})
        </router-link>
      </template>
    </pagination>
  </div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import EmailNav from '@/components/EmailNav'
import NewsletterNav from '@/components/NewsletterNav'
import EmailRecipientStatusKey from '@/components/EmailRecipientStatusKey'

import EmailMixin from '@/mixins/EmailMixin'

export default {
  data () {
    return {
      orderBy: 'created_at',
      pageResponse: undefined,
      recipients: [],
      // We need `email-recipient-status-key` for styling,
      // but don't want to display it because it muddles matters.
      showKey: false
    }
  },

  props: {
    status: {
      type: String,
      default: 'delivered'
    }
  },

  components: {
    'email-nav': EmailNav,
    'newsletter-nav': NewsletterNav,
    'pagination': Pagination,
    'email-recipient-status-key': EmailRecipientStatusKey
  },

  computed: {
    resourceUrl () {
      return this.apiUrl(`/${this.modelType}s/${this.baseId}/status/${this.status}`, true)
    }
  },

  mixins: [
    EmailMixin
  ],

  created () {
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipientStats.vue